import React from "react";

export default function StarDivider({ className = "", color = "#5BA63B", inline = false }) {
  const wrap = inline ? "inline-flex" : "flex";
  return (
    <div className={`${wrap} items-center justify-center gap-2 ${className}`} aria-hidden="true">
      <span className="block h-[2px] w-12 rounded" style={{ background: color, opacity: 0.85 }} />
      <Star color={color} />
      <Star color={color} />
      <Star color={color} />
      <span className="block h-[2px] w-12 rounded" style={{ background: color, opacity: 0.85 }} />
    </div>
  );
}

function Star({ color }) {
  return (
    <svg width="14" height="14" viewBox="-7 -7 14 14" xmlns="http://www.w3.org/2000/svg">
      <polygon
        points="0,-6.5 1.7,-2 6.5,-2 2.7,0.9 4.1,5.5 0,2.8 -4.1,5.5 -2.7,0.9 -6.5,-2 -1.7,-2"
        fill={color}
      />
    </svg>
  );
}
